export interface IExamLevel {
  id: number;
  shortName: string;
  name: string;
}

export interface IFreeCourse {
  id: number;
  name: string;
  locale: string;
  description: string;
  price: number;
  levels: IExamLevel[];
}

export interface IFreeCoursesApiResponse {
  currentPage: number;
  totalPages: number;
  totalCount: number;
  perPage: number;
  exams: IFreeCourse[];
}

export interface IFreeCoursesFetchResponse {
  records: IFreeCourse[];
  totalCount: number;
  totalPages: number;
  currentPage: number;
}

/**
 * Sentinel for the exam-language filter meaning "every language". The API
 * narrows to the team's teaching language when no `exam_locale` is sent, so an
 * empty filter has to be spelled out rather than omitted.
 */
export const ALL_EXAM_LOCALES = 'all';

export interface IFreeCoursesParams {
  page?: number;
  per_page?: number;
  level_ids?: number[];
  /**
   * Language to scope the exam list to, or `ALL_EXAM_LOCALES` for every
   * language at once. Deliberately not named `locale`: the API applies and
   * persists `locale` as the user's UI language on every request, so sending
   * the exam filter under that name rewrote the student's own language.
   * Omitting it entirely falls back to the team's teaching language, which is
   * not the same thing as an empty filter — see ALL_EXAM_LOCALES.
   */
  exam_locale?: string;
  query?: string;
}

export interface IExamLevelsResponse {
  levels: IExamLevel[];
}

export interface IExaminationResponse {
  examination: {
    id: number;
    status: string;
    title: string;
    locale: string;
    url: string;
    expires_at: string;
    created_at: string;
  };
}
